import { VFooter } from 'vuetify/lib/components/VFooter';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VFooter,{staticClass:"footer px-6 py-4",attrs:{"app":"","height":"auto","fixed":""}},[_c(VRow,_vm._l((_vm.dataFooter),function(item){return _c('p',{key:item.title,staticClass:"px-3 ma-0"},[_c('a',{staticClass:"footer__title",attrs:{"target":"_blank","href":item.link}},[_vm._v(" "+_vm._s(item.title)+" ")])])}),0),_c('span',{staticClass:"footer__company-name"},[_vm._v(" © "+_vm._s(_vm.companyName)+" "+_vm._s(_setup.year)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }